import { AfterContentChecked, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NzNotificationService } from "ng-zorro-antd";
import { floatToStringFormat, stringFormatToFloat } from 'src/app/fieldTypes/TextFields';
import { FormsService } from 'src/app/services/forms.service';
import { FieldTypeCode, TITLE } from 'src/app/utils/enum';
import { FormFieldInfo } from '../../../../models/forms-response.models';

@Component({
    selector: 'app-component-multiple-choice',
    templateUrl: './multiple-choice.component.html',
    styleUrls: ['./multiple-choice.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultipleChoiceComponent implements OnInit, AfterViewInit, OnChanges, AfterContentChecked {
    @Input() formFieldInfo: FormFieldInfo;
    @Input() listFormFieldInfo: FormFieldInfo[];
    @Input() itemList: FormFieldInfo[];
    @Input() inputCustomfieldOptionList: any[];
    @Input() formData: any;
    @Input() modalTitle:any;
    @Input() public formGroup: FormGroup;
    @Input() formFieldCode: string;

    formFieldConfig: any;
    fieldConfig: any;
    name: string;
    hideTitle: boolean;
    tooltip: string;
    isHiglineField: any;
    itemSubSection: any;
    fieldDataInfo:any;
    dependentField = [];
    unDependentOption = [];
    customfieldOptionList = [];
    dependentFieldsOption = [];
    checkboxValue: string;
    fieldCode: string;
    isNumeric: boolean;
    checkboxInput: string;
    isHiddenSubItem = true;
    allowInput = false;
    ngModelCheckbox = [];
    numberFormFieldInfo: any;
    selectChildData: any;
    taxCode="";
    formCode="";

    constructor(
        private nzModalNotification: NzNotificationService,
        private elementRef: ElementRef,
        private cdref: ChangeDetectorRef,
        private formService: FormsService) {
    }

    ngOnChanges() {}

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    ngOnInit(): void {
        try {
            this.formFieldConfig = this.formFieldInfo.formFieldConfig ? JSON.parse(this.formFieldInfo.formFieldConfig) : "";
            this.fieldConfig = this.formFieldInfo.fieldConfig ? JSON.parse(this.formFieldInfo.fieldConfig) : "";
            this.fieldCode = this.formFieldInfo.fieldCode;
            this.fieldDataInfo = this.formFieldInfo;
            if (this.fieldConfig) {
                this.dependentField = this.fieldConfig.dependentField;
                this.unDependentOption = this.fieldConfig.unDependentOption;
                this.isNumeric = this.fieldConfig.isNumeric ? this.fieldConfig.isNumeric : false;
            }

            if (this.formFieldConfig) {
                this.isHiglineField = this.formFieldConfig.isHiglineField;
                this.itemSubSection = this.formFieldConfig.itemSubSection;
            }

            this.hideTitle = (this.formFieldConfig && this.formFieldConfig.hideTitle) ? this.formFieldConfig.hideTitle : false;
            this.name = (this.formFieldConfig && this.formFieldConfig.displayText) ? this.formFieldConfig.displayText : this.formFieldInfo.name;
            this.tooltip = this.formFieldConfig && this.formFieldConfig.tooltip ? this.formFieldConfig.tooltip : "";
            this.formCode=localStorage.getItem('FORM_CODE');
            this.taxCode=localStorage.getItem('TAXCODE');
            
            this.bindingData();
        } catch (error) {
            this.formFieldConfig = JSON.parse('{ "pattern": "" }');
            this.fieldConfig = JSON.parse('{ "keydownPattern": "" }');
        }
    }

    bindingData(){
        this.customfieldOptionList = this.formFieldInfo.customfieldOptionList;
        let storageVal = localStorage.getItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ this.fieldCode) 
                ? localStorage.getItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ this.fieldCode).split(',') 
                : [];

        if(storageVal){
            for(let i=0;i<storageVal.length;i++){
                let item=storageVal[i];
                storageVal[i]=item.substring(item.indexOf('#')+1);
            }
            localStorage.setItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ this.fieldCode,storageVal.join(','))
        }   
        if (this.modalTitle == TITLE.ADD_DATA)//This case is: Click icon(+) to open popup
        {
            this.customfieldOptionList.forEach(opt => {
                opt.checked = false;
                opt.disabled = false;
            });        
        }
        else if (this.modalTitle == TITLE.UPDATE_DATA) { //This case is: Click icon(edit) to open popup
            if (this.formData) {
                let objectData = this.formData;
                const keys = Object.keys(objectData);
                keys.forEach((key) => {
                    if (key == this.formFieldInfo.fieldCode) {
                        let value = objectData[key];
                        this.customfieldOptionList.forEach(opt => {
                            if(value.includes(opt.optionCode)){
                                opt.checked = true;
                            }
                            else if (value.includes(opt.optionValue) || value.includes(opt.optionValue.slice(0,opt.optionValue.length - 1)))
                                opt.checked = true;
                            else
                                opt.checked = false;

                            opt.disabled = false;
                        });
                    }
                });
            }
        }
        else {
            this.customfieldOptionList.forEach(opt => {
                if (storageVal && storageVal.length > 0){
                    opt.checked =(storageVal.indexOf(opt.optionCode) >= 0)? true:false;
                } 
                else{
                    opt.checked = (this.formGroup.controls[opt.fieldCode + '-' + opt.optionCode].value)? true:false;
                } 
                opt.disabled = false;
            });
        }
        if (this.customfieldOptionList) {
            for (let i = 0; i < this.customfieldOptionList.length; i++) {
                let item = this.customfieldOptionList[i];
                let fieldOptionConfig = JSON.parse(item.fieldOptionConfig);
                this.dependentFieldsOption = [{ fieldCode: "", fieldsOptionList: [] }];
                let hasSubSession = false;
                let optionClass = "col-sm-3";
                if (fieldOptionConfig) {
                    hasSubSession = fieldOptionConfig.hasSubSession ? fieldOptionConfig.hasSubSession : false;
                    this.dependentFieldsOption = fieldOptionConfig.dependentFieldsOption || fieldOptionConfig.dependentFieldsOption;
                }   

                this.customfieldOptionList[i].hasSubSession = hasSubSession;
                this.customfieldOptionList[i].optionClass = optionClass;
            }
        }
    }

    ngAfterViewInit() {
        // if (this.inputCustomfieldOptionList) {
        //     for (let i = 0; i < this.inputCustomfieldOptionList.length; i++) {
        //         let item = this.inputCustomfieldOptionList[i];
        //         document.getElementById(`multi${item.fieldCode}-${item.optionCode}`).addEventListener('click', () => {
        //             let config = item.fieldOptionConfig ? JSON.parse(item.fieldOptionConfig) : null;
        //             if (config) {
        //                 let option = config.dependentFieldsOption.find(x => x.fieldCode == this.fieldCode);
        //                 option.fieldsOptionList.forEach(el => {
        //                     if (el.AllowChange) {
        //                         this.customfieldOptionList.find(x => x.optionCode == el.Option).checked = true;
        //                     } else {
        //                         this.customfieldOptionList.find(x => x.optionCode == el.Option).disabled = true;
        //                     }
        //                 });
        //             }
        //         })
        //     }
        // }
        // if (this.formData) {
        //     this.setSubItemsValue();
        // }
    }

    changeCheckboxValue() {
        let arrVal = [];
        this.customfieldOptionList.forEach(opt => {
            if (opt.checked) {
                arrVal.push(opt.optionCode);
                localStorage.setItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ this.fieldCode, arrVal.join(','));
            }
        });
    }

    setSubItemsValue() {
        this.formFieldInfo.customfieldOptionList.forEach(option => {
            if(option.optionCode=='SMS' || option.optionCode=='EMAIL'){
                if (this.formData[option.fieldCode + '-' + option.optionCode]) {
                    let value=this.formData[option.fieldCode + '-' + option.optionCode];
                    (<HTMLInputElement>document.getElementById(`${option.fieldCode}-${option.optionCode}_INPUT`)).value=value;
                    option.checked=true;
                    option.selectedInput=value;
                }
            }
            else{
                if (this.formData[option.fieldCode + '-' + option.optionCode]) {
                    var itemList = [];
                    for (const x of this.listFormFieldInfo) {
                        if (x.formFieldConfig) {
                            let config = JSON.parse(x.formFieldConfig)
                            if (config && config.itemSubSection) {
                                for (const opt of this.formFieldInfo.customfieldOptionList) {
                                    if (config.itemSubSection == opt.fieldCode + '-' + opt.optionCode) {
                                        itemList.push(x);
                                    }
                                }
                            }
                        }
                        return false;
                    };
                }
            }
        })
        // this.itemList.forEach(item => {
        //     this.formGroup.controls[item.fieldCode].setValue(this.formData[item.fieldCode]);
        // });
    }

    getCol(item: any) {
        if (item.fieldTypeCode == FieldTypeCode.TITLE) {
            return 'col-md-12';
        }
        else {
            return 'col-md-' + (item.width * 12 / 3) + ' col-xs-12';
        }
    }

    focusInput(option) {
        this.checkboxValue = option.optionCode;
    }

    addClass(config) {
        if (config) {
            return JSON.parse(config) && JSON.parse(config).optionClass ? JSON.parse(config).optionClass : "";
        }

        return "";
    }

    checkValidEmail(option:any){
        if(option.optionCode=='EMAIL'){
            let message = "";
            let smsInput:any = <HTMLInputElement>document.getElementById(`${option.fieldCode}-${option.optionCode}_INPUT`);
            let validate = true;
            var fieldOption = JSON.parse(option.fieldOptionConfig);
            var keydownPattern=fieldOption.keydownPattern;
            let checkboxInput:any = (smsInput).value;
            if (keydownPattern) {
                var pattern = new RegExp(keydownPattern);
                if (pattern) {
                    if (checkboxInput && checkboxInput.indexOf('@')<0) {
                        validate = false;
                        message = "sai định dạng format";
                        checkboxInput = checkboxInput.substring(0, checkboxInput.length - 1);
                    }
                }

                if (!validate) {
                    this.nzModalNotification.error("Cảnh báo", "Chuỗi " + message);
                    return true;
                }
            }
        }
        else{
            
        }
    }

    keydownValidateAllowInput(option:any) {
        let message = "";
        let smsInputLength:number=0;
        let smsInput:any = <HTMLInputElement>document.getElementById(`${option.fieldCode}-${option.optionCode}_INPUT`);
        let validate = true;
        var number: any;
        var fieldOption = JSON.parse(option.fieldOptionConfig);
        var keydownPattern=fieldOption.keydownPattern;
        let numberInput=parseInt(fieldOption.onchangePattern.substring(fieldOption.onchangePattern.indexOf('{')+1,fieldOption.onchangePattern.indexOf('}')));
        let checkboxInput:any = (smsInput).value;
        let inputArray=checkboxInput.split(';');
        if (this.isNumeric) {
            number = parseFloat(stringFormatToFloat(checkboxInput).toString());
            if (isNaN(number) || number) {
                validate = false;
                message = " sai định dạng format";
            } else {
                var valNumber = checkboxInput.replace(/[\*\^\,\'\!]/g, '');
                if (checkboxInput != "") {
                    number = stringFormatToFloat(checkboxInput);
                    if (checkboxInput.split('.')[1]) {
                        var valueNumeric = floatToStringFormat(number);
                        checkboxInput = valueNumeric;
                    }
                    else {
                        var valueNumeric = floatToStringFormat(number);
                        if (checkboxInput.includes('.')) {
                        } else {
                            checkboxInput = valueNumeric;
                        }
                    }
                }
            }
        }

        if (keydownPattern) {
            var pattern = new RegExp(keydownPattern);
            if (pattern) {
                if (!pattern.test(checkboxInput) && checkboxInput) {
                    validate = false;
                    message = "sai định dạng format";
                    checkboxInput = checkboxInput.substring(0, checkboxInput.length - 1);
                }
            }

            if (!validate) {
                this.nzModalNotification.error("Cảnh báo", "Chuỗi " + message);
                return true;
            }
        }
        if(option.optionCode=='SMS'){
            if(checkboxInput.indexOf(';') < 0){
                if(checkboxInput.length>=numberInput){
                    (smsInput).value +='; ' ;
                }
            }
            else{
                let typedSms=inputArray[inputArray.length-1].trim();
                smsInputLength=typedSms.length;
                if(smsInputLength>=numberInput){
                    (smsInput).value +='; ' ;
                }
            }
        }
        option.selectedInput=(smsInput).value;
    }

    changeValidate(option: any){
        let validate = true;
        let message: string = 'sai định dạng format!';
        let smsInput:any = <HTMLInputElement>document.getElementById(`${option.fieldCode}-${option.optionCode}_INPUT`);
        var fieldOption = JSON.parse(option.fieldOptionConfig);
        var onchangePattern = fieldOption.onchangePattern;
        let checkboxInput: any = (smsInput).value;
        
        if(option.optionCode && onchangePattern){
            var changePattern = new RegExp(onchangePattern);
            
            if (changePattern) {
                if (!changePattern.test(checkboxInput) && checkboxInput) {
                    validate = false;
                    checkboxInput = checkboxInput.substring(0, checkboxInput.length - 1);
                }
            }

            if (!validate) {
                this.nzModalNotification.error("Cảnh báo", "Chuỗi " + message);
                return true;
            }
        }
    }

    selectOutput(item) {
        this.selectChildData = [];
        if (item) {
            if (this.listFormFieldInfo) {
                var childField = this.listFormFieldInfo.find(x => {
                    if (x.fieldConfig) {
                        var config = (x.fieldConfig && x.fieldConfig.indexOf('input') > -1) ? JSON.parse(x.fieldConfig) : null;
                        var parentId = config && config.apiConfig && config.apiConfig.request ? config.apiConfig.request.input : '';
                        if (item.fieldInfo.fieldCode == parentId) {
                            return true;
                        }
                    }
                    return false;
                })
            }

            if (childField) {
                this.selectChildData = { fieldCode: childField.fieldCode, data: [] };
                let fieldConfig = childField.fieldConfig ? JSON.parse(childField.fieldConfig) : null;
                if (fieldConfig && fieldConfig.apiConfig.url) {
                    if (item.input && item.input.dataValueField) {
                        this.formService.callApiUrl(fieldConfig.apiConfig.url, { input: item.input.dataValueField }).subscribe(
                            res => {
                                if (res.result && res.result.length > 0) {
                                    this.selectChildData = { fieldCode: childField.fieldCode, data: res.result };
                                }
                            },
                            error => {
                                console.log(error);
                            }
                        )
                    }
                }
            }
        }
    }

    tableOutput(e) {
        console.log(e);
    }

    getSubItemsList(component: FormFieldInfo) {
        let fieldCode = component.fieldCode;
        // MULTIPLE_CHOICE_RegisterAlert
        if (this.listFormFieldInfo) {
            var itemList = this.listFormFieldInfo.filter(x => {
                if (x.formFieldConfig) {
                    let config = JSON.parse(x.formFieldConfig)
                    if (config && config.itemSubSection) {
                        for (const opt of component.customfieldOptionList) {
                            if (config.itemSubSection == opt.fieldCode + '-' + opt.optionCode) {
                                return true;
                            }
                        }
                    }
                }

                return false;
            });
        } else {
            itemList = [];
        }

        return itemList;
    }

    getMultipleChoiceCustomfieldList(component: FormFieldInfo) {
        var fieldCode = component.fieldCode;
        let formFieldInfo = this.listFormFieldInfo.filter(x => {
            let fieldConfig = (x.fieldConfig && x.fieldConfig.indexOf('dependentField') > -1) ? JSON.parse(x.fieldConfig) : null;

            if (fieldConfig && fieldConfig.dependentField) {
                return fieldConfig.dependentField.indexOf(component.fieldCode) > -1;
            }

            return false;
        })
        let filteredFormFieldInfo = (formFieldInfo!=null)?formFieldInfo[0]:null;

        if (filteredFormFieldInfo) {
            var filteredCustomfieldOptionList = filteredFormFieldInfo.customfieldOptionList.filter(x => {
                let fieldOptionConfig = x.fieldOptionConfig ? JSON.parse(x.fieldOptionConfig) : null;
                if (fieldOptionConfig) {
                    let dependentFieldsOption = fieldOptionConfig.dependentFieldsOption.filter(y => y.fieldCode == fieldCode)[0];
                    return dependentFieldsOption.fieldCode == fieldCode;
                }
                return false;
            });
        }

        return filteredCustomfieldOptionList;
    }

    numberAddEvent(value) {
        this.numberFormFieldInfo = value;
    }

    isShow(item, option) {
        let config = JSON.parse(item.formFieldConfig);
        if (config && config.itemSubSection) {
            if (config.itemSubSection == `${option.fieldCode}-${option.optionCode}` && option.checked) {
                this.isHiddenSubItem=false
                return true;
            }
            else{
                this.isHiddenSubItem=true;
            }
        }

        return false;
    }
}